import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import { monthOptions, yearOptions } from "../../../config";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import { buildSheet, tableConfig } from "./config";
import moment from "moment";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import Api from "../../../../../../Services/Api";
import { HttpStatus } from "../../../../../common/Constants";
import { saveAs } from "file-saver";
//  type = 'service' | 'unit_entri'

export default class LaporanUnitHarian extends Component {
  constructor(props) {
    super(props);
    this.currentMonth = Number(moment().format("MM"));
    this.currentYear = Number(moment().format("YYYY"));

    this.state = {
      month: monthOptions.find((item) => item.value === this.currentMonth),
      year: yearOptions.find((item) => item.value === this.currentYear),
      dataTable: [],
      search: {
        year: this.currentYear,
        month: this.currentMonth,
      },
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps, prevState) {
    const currCabang = this.props.kodeCabang?.value;
    const prevCabang = prevProps?.kodeCabang?.value;
    if (currCabang !== prevCabang) {
      this.fetchData();
    }
  }

  handleChangeValue = (name, value) => {
    this.setState((prevValue) => ({ ...prevValue, [name]: value }));
  };

  handleSearch = () => {
    this.setState(
      (prev) => ({
        ...prev,
        search: {
          month: prev.month?.value,
          year: prev?.year?.value,
        },
      }),
      () => this.fetchData(),
    );
  };

  fetchData = async () => {
    const { setError, onTriggerLoading, kodeCabang, type } = this.props;
    const { month, year } = this.state;
    const userId = localStorage.getItem("userId");
    if (!kodeCabang?.value) return;

    onTriggerLoading();

    const fn =
      type === "unit_entri"
        ? "getLaporanUnitEntryHarianByMekanikH23"
        : "getLaporanUnitServiceHarianByMekanikH23";

    const title =
      type === "unit_entri"
        ? "Laporan Unit Entri Harian"
        : "Laporan Unit Servis Harian";
        
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT_DTO")[fn],
      setError: setError,
      menuName: `Dashboard Level Mekanik & SA - ${title}`,
      args: {
        kodeCabang: kodeCabang?.value,
        month: month?.value,
        year: year?.value,
        idUser: userId,
        type: "MECHANICSA",
      },
    });

    onTriggerLoading();

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState({
        dataTable: res.data.data,
      });
    }
  };

  constructData = (data = []) => {
    return data.map(({ totalDaily, ...rest }) => ({
      ...totalDaily,
      ...rest,
    }));
  };

  constructData = (data = []) => {
    return data.map(({ totalDaily, ...rest }) => ({
      ...totalDaily,
      ...rest,
    }));
  };

  renderTable = () => {
    const { dataTable, config, search } = this.state;
    if (Object.values(dataTable).every((item) => !item)) {
      return (
        <SimpleDataTable
          data={[]}
          columns={config}
          options={{ pagination: false }}
        />
      );
    }

    return Object.keys(dataTable || {}).map((key) => {
      if (!dataTable[key]) return null;
      const title = key === "sa" ? "Tim Service Advisor" : "Tim Mekanik";
      return (
        <div className="margin-top-20px" key={`table-${key}`}>
          <SimpleDataTable
            data={this.constructData(dataTable[key])}
            columns={tableConfig(search?.year, search?.month, title)}
            options={{ pagination: false }}
          />
        </div>
      );
    });
  };

  exportExcel = async ({ reqBody, title, setError }) => {
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT").generateExcelFromPayload,
      setError,
      menuName: `Dashboard Mekanik SA - ${title}`,
      args: reqBody,
    });

    if (res.ok) {
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, `${reqBody.filename}.xlsx`);
    }

    return res.ok;
  };

  handlePrint = async () => {
    const { onTriggerLoading, type, setError } = this.props;
    const { dataTable } = this.state;

    const titleMap = {
      service: "Dashboard Mekanik SA Laporan Unit Servis Harian",
      unit_entri: "Dashboard Mekanik SA Laporan Unit Entri Harian",
    };

    const title = titleMap[type];
    const fileName = title.replace(/\s+/g, "_");

    const datasets = [
      {
        key: "sa",
        label: "Tim Service Advisor",
        suffix: "SA",
        data: this.constructData(dataTable.sa || []),
      },
      {
        key: "mechanic",
        label: "Tim Mekanik",
        suffix: "MECHANIC",
        data: this.constructData(dataTable.mechanic || []),
      },
    ];

    onTriggerLoading();

    await Promise.all(
      datasets.map(({ label, suffix, data }) =>
        this.exportExcel({
          title,
          setError,
          reqBody: {
            filename: `${fileName}_${suffix}`,
            sheets: [
              buildSheet({
                title: `${title} - ${suffix}`,
                nameLabel: label,
                data,
              }),
            ],
          },
        }),
      ),
    );

    onTriggerLoading();
  };

  render() {
    const { month, year } = this.state;
    return (
      <React.Fragment>
        <FlexView className="margin-top-15px" style={{ gap: "20px" }}>
          <SimpleDDL
            id="select_options_bulan"
            box="search"
            name="month"
            containerclassname="width width-150px"
            placeholder="Bulan"
            options={monthOptions}
            value={month}
            onChange={(value, { name }) => this.handleChangeValue(name, value)}
          />
          <SimpleDDL
            id="select_options_tahun"
            box="search"
            name="year"
            containerclassname="width width-150px"
            placeholder="Tahun"
            options={yearOptions}
            value={year}
            onChange={(value, { name }) => this.handleChangeValue(name, value)}
          />
          <SimpleButton
            id="btn_search"
            text="Cari"
            className="margin margin-top-5px"
            onClick={() => this.handleSearch()}
          />
        </FlexView>
        {this.renderTable()}
        <FlexView hAlignContent="right" className="margin-top-20px">
          <SimpleButton
            id="btn_print"
            text="CETAK"
            onClick={() => this.handlePrint()}
          />
        </FlexView>
      </React.Fragment>
    );
  }
}
